export default __webpack_public_path__ + "static/media/Text(Nobid).1ae2c873.svg";